/**
 * Ils nous font confiance — injection des logos + bandeaux animés.
 */
(function () {
  'use strict';

  var root = document.querySelector('.confiance');
  if (!root) return;

  var mount = root.querySelector('[data-confiance-bandeaux-mount]');
  var dataEl = document.getElementById('confiance-logos-data');
  if (!mount || !dataEl) return;

  var logos = [];
  try {
    logos = JSON.parse(dataEl.textContent || '[]');
  } catch (e) {
    return;
  }

  if (!logos.length) {
    if (window.Shopify && window.Shopify.designMode) {
      mount.innerHTML =
        '<p class="confiance__empty">Aucun logo — ouvrez l\'app DasiFrères → Ils nous font confiance → Importer → Appliquer au thème.</p>';
    }
    return;
  }

  var displayMode = root.dataset.displayMode || 'dual_infinite';
  var loopType = root.dataset.loopType || 'infinite';
  var groupSize = parseInt(root.dataset.groupSize || '4', 10) || 4;
  var directions = [
    root.dataset.bandeau1Direction || 'left',
    root.dataset.bandeau2Direction || 'right',
    root.dataset.bandeau3Direction || 'left',
  ];

  function createLogo(url, nom) {
    var wrap = document.createElement('div');
    wrap.className = 'confiance-bandeau__logo';
    var img = document.createElement('img');
    img.src = url;
    img.alt = nom || 'Logo partenaire';
    img.loading = 'lazy';
    img.width = 200;
    img.height = 80;
    wrap.appendChild(img);
    return wrap;
  }

  function createViewport(direction) {
    var vp = document.createElement('div');
    vp.className = 'confiance-bandeau__viewport';
    vp.dataset.loop = loopType;
    vp.dataset.direction = direction;
    var track = document.createElement('div');
    track.className = 'confiance-bandeau__track';
    vp.appendChild(track);
    return { vp: vp, track: track };
  }

  function resolveBandeau(logo, index, bandeauCount) {
    if (logo.bandeau && logo.bandeau !== 'auto') return parseInt(logo.bandeau, 10);
    if (displayMode === 'dual_infinite') return (index % 2) + 1;
    if (displayMode === 'triple_finite') return (index % 3) + 1;
    return 1;
  }

  function appendStacked(track) {
    track.classList.add('confiance-bandeau__track--stacked');
    for (var i = 0; i < logos.length; i += groupSize) {
      var group = document.createElement('div');
      group.className = 'confiance-bandeau__group';
      for (var j = i; j < Math.min(i + groupSize, logos.length); j++) {
        group.appendChild(createLogo(logos[j].url, logos[j].nom));
      }
      track.appendChild(group);
    }
  }

  if (displayMode === 'stacked_groups' || displayMode === 'single_infinite') {
    var single = createViewport(directions[0]);
    if (displayMode === 'stacked_groups') {
      appendStacked(single.track);
    } else {
      for (var s = 0; s < logos.length; s++) {
        single.track.appendChild(createLogo(logos[s].url, logos[s].nom));
      }
    }
    mount.appendChild(single.vp);
  } else {
    var count = displayMode === 'triple_finite' ? 3 : 2;
    var tracks = [];
    for (var b = 0; b < count; b++) {
      var band = createViewport(directions[b] || 'left');
      band.vp.dataset.bandeau = String(b + 1);
      tracks.push(band);
      mount.appendChild(band.vp);
    }
    for (var k = 0; k < logos.length; k++) {
      var bn = resolveBandeau(logos[k], k, count);
      if (bn >= 1 && bn <= count) {
        tracks[bn - 1].track.appendChild(createLogo(logos[k].url, logos[k].nom));
      }
    }
  }

  var prefersReduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var viewports = mount.querySelectorAll('.confiance-bandeau__viewport');
  for (var v = 0; v < viewports.length; v++) {
    var viewport = viewports[v];
    var trackEl = viewport.querySelector('.confiance-bandeau__track');
    if (!trackEl || !trackEl.children.length) {
      viewport.classList.add('is-ready');
      continue;
    }

    if (!prefersReduced) {
      var clone = trackEl.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      while (clone.firstChild) {
        trackEl.appendChild(clone.firstChild);
      }
    }

    viewport.classList.add('is-ready');
  }
})();